import { render, staticRenderFns } from "./AdsStatus.vue?vue&type=template&id=180de2e6&scoped=true"
import script from "./AdsStatus.vue?vue&type=script&lang=js"
export * from "./AdsStatus.vue?vue&type=script&lang=js"
import style0 from "./AdsStatus.vue?vue&type=style&index=0&id=180de2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180de2e6",
  null
  
)

export default component.exports